// export let API_URL = "http://localhost:3005/api";
export let API_URL = "https://api.cv-diffusion.com/api";